import { useState, useEffect } from "react";
import { apiCall } from "../api";

// Payment Success Component
const PaymentSuccess = () => {
  const [status, setStatus] = useState('checking');
  const [message, setMessage] = useState('Verificando estado del pago...');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    
    if (sessionId) {
      pollPaymentStatus(sessionId);
    } else {
      setStatus('error');
      setMessage('No se encontr\u00f3 el ID de sesi\u00f3n');
    }
  }, []);

  const pollPaymentStatus = async (sessionId, attempts = 0) => {
    const maxAttempts = 10;
    
    if (attempts >= maxAttempts) {
      setStatus('error');
      setMessage('La verificaci\u00f3n del pago agot\u00f3 el tiempo. Por favor contacta soporte.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const result = await apiCall(`/payments/checkout/status/${sessionId}`, 'GET', null, token);
      
      if (result.payment_status === 'paid') {
        setStatus('success');
        setMessage(result.purpose === 'report_unlock'
          ? '\u00a1Pago exitoso! El reporte completo del inquilino ya est\u00e1 desbloqueado. B\u00fascalo de nuevo para verlo.'
          : '\u00a1Pago exitoso! Tu calificaci\u00f3n de inquilino ha sido enviada.');
        return;
      } else if (result.status === 'expired') {
        setStatus('error');
        setMessage('La sesi\u00f3n de pago expir\u00f3. Por favor intenta de nuevo.');
        return;
      }

      // Continue polling
      setTimeout(() => pollPaymentStatus(sessionId, attempts + 1), 2000);
    } catch (error) {
      setStatus('error');
      setMessage('Error al verificar el estado del pago.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-5 sm:p-8 max-w-md w-full text-center">
        {status === 'checking' && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Procesando Pago</h2>
            <p className="text-gray-600">{message}</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">&iexcl;Pago Exitoso!</h2>
            <p className="text-gray-600 mb-6">{message}</p>
            <button
              onClick={() => window.location.href = '/'}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
            >
              Volver al Panel
            </button>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Pago Fallido</h2>
            <p className="text-gray-600 mb-6">{message}</p>
            <button
              onClick={() => window.location.href = '/'}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
            >
              Intentar de Nuevo
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export { PaymentSuccess };
